import React, { useState } from "react";
import axios from "axios";
import Register from "../Register/Register";
import { useTranslation } from "react-i18next";
import "./login.css";
const REACT_APP_EXPRESS_API = process.env.REACT_APP_EXPRESS_API;

function Login({ show, onClose }) {
  const { t } = useTranslation();
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [message, setMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [showRegister, setShowRegister] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginForm((prev) => ({ ...prev, [name]: value }));
  };

  const sendLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    try {
      await axios.post(
        `${REACT_APP_EXPRESS_API}/api/v2/auth/login`,
        { email: loginForm.email, password: loginForm.password },
        { headers: { "Content-Type": "application/json" }, withCredentials: true }
      );
      window.location.href = "/dashboard";
    } catch (err) {
      console.error("Error during login:", err.response?.data || err.message);
      setMessage(err.response?.data?.message || "Login gagal, periksa email/password Anda.");
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = `${REACT_APP_EXPRESS_API}/api/v2/auth/google`;
  };

  // 🔹 Fungsi untuk beralih ke modal register
  const handleSwitchToRegister = () => {
    setShowRegister(true); // tampilkan register
  };

  // 🔹 Tutup login saat register dibuka
  if (!show || showRegister) return showRegister ? <Register show={true} onClose={() => setShowRegister(false)} /> : null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-btn-masuk" onClick={onClose} aria-label="Tutup">
          ✕
        </button>

        <h2>{t("login.title")}</h2>
        <p>{t("login.subtitle")}</p>

        <form className="login-form" onSubmit={sendLogin}>
          <label htmlFor="email">{t("login.email_label")}</label>
          <input
            id="email"
            type="email"
            name="email"
            placeholder={t("login.email_placeholder")}
            value={loginForm.email}
            onChange={handleChange}
            required
          />

          <label htmlFor="password">{t("login.password_label")}</label>
          <div className="password-wrapper">
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder={t("login.password_placeholder")}
              value={loginForm.password}
              onChange={handleChange}
              required
            />
            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "🙈" : "👁️"}
            </span>
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              {t("login.remember_me")}
            </label>
          </div>

          <button type="submit" className="btn-login">
            {t("login.btn_login")}
          </button>

          <div className="login-divider">
            <span>{t("login.or")}</span>
          </div>

          <button type="button" onClick={handleGoogleLogin} className="btn-google-login">
            <span>{t("login.btn_google")}</span>
          </button>

          {message && <p className="login-message">{message}</p>}

          <p className="register-text">
            {t("login.no_account")}{" "}
            <strong
              className="daftar-disini"
              style={{ cursor: "pointer", color: "#3C5896" }}
              onClick={handleSwitchToRegister}
            >
              {t("login.register_here")}
            </strong>
          </p>
        </form>
      </div>
    </div>
  );
}

export default Login;
